class Favorites {
  constructor() {
    this.blocks = document.querySelectorAll('[data-shortcode="favorites"]');

    if (0 !== this.blocks.length) {
      this.blocks.forEach(block => {
        new Controller(block);
      });
    }
  }
}

class Controller {
  constructor(block) {
    this.el = $(block);
    this.type = this.el.data('type') || '';
    this.config = {
      leagues: [],
      teams: [],
    },

    this.triggers = {
      add: this.el.find('[data-trigger="add"]'),
      remove: this.el.find('[data-trigger="remove"]'),
    }

    switch (this.type) {
      case 'league':
        this.config.leagues.push({
          id: parseInt(this.el.data('id') || 0),
        });
        break;

      case 'team':
        this.config.teams.push({
          id: parseInt(this.el.data('id') || 0),
          sport: this.el.data('sport') || '',
          gender: this.el.data('gender') || '',
        });
        break;
    }

    this.initEvents();
  }

  initEvents() {
    this.el.addClass('-loading');

    $(document).on('bvm_shortcode_favorites_error', (e, item) => {
      if (this.equal(item, this.getItem())) {
        this.el.removeClass('-loading');
      }
    });

    $(document).on('bvm_shortcode_favorites_adding', (e, item) => {
      if (this.equal(item, this.getItem())) {
        this.el.addClass('-loading');
      }
    });

    $(document).on('bvm_shortcode_favorites_added', (e, item) => {
      if (this.equal(item, this.getItem())) {
        this.triggers.add.hide();
        this.triggers.remove.show();
        this.el.removeClass('-loading');
      }
    });

    $(document).on('bvm_shortcode_favorites_removing', (e, item) => {
      if (this.equal(item, this.getItem())) {
        this.el.addClass('-loading');
      }
    });

    $(document).on('bvm_shortcode_favorites_removed', (e, item) => {
      if (this.equal(item, this.getItem())) {
        this.triggers.add.show();
        this.triggers.remove.hide();
        this.el.removeClass('-loading');
      }
    });

    $(document).on('bvm_config_ready', () => {
      this.initTriggers();
    });
  }

  initTriggers() {
    this.triggers.add.on('click', () => {
      this.add();
    });

    this.triggers.remove.on('click', () => {
      this.remove();
    });

    if (this.hasItem()) {
      $(document).trigger('bvm_shortcode_favorites_added', this.getItem());
    } else {
      $(document).trigger('bvm_shortcode_favorites_removed', this.getItem());
    }
  }

  add() {
    $.ajax({
      url: window.bvm.ajax,
      method: 'POST',
      data: {
        action: 'bvm_account_follow',
        mode: 'add',
        ...this.config,
      },
      beforeSend: () => {
        $(document).trigger('bvm_shortcode_favorites_adding', this.getItem());
      },
    })
      .done((result) => {
        if (result.success) {
          $(document).trigger('bvm_shortcode_favorites_added', this.getItem());

          if (! this.hasUser()) {
            this.redirect();
          }
        } else {
          alert(result.data.errors.general);
          $(document).trigger('bvm_shortcode_favorites_error', this.getItem());
        }
      })
      .fail(error => {
        alert('Can\'t add team to favorites. Try again later.');
        console.error(error);
      });
  }

  remove() {
    $.ajax({
      url: window.bvm.ajax,
      method: 'POST',
      data: {
        action: 'bvm_account_follow',
        mode: 'remove',
        ...this.config,
      },
      beforeSend: () => {
        $(document).trigger('bvm_shortcode_favorites_removing', this.getItem());
      },
    })
      .done((result) => {
        if (result.success) {
          $(document).trigger('bvm_shortcode_favorites_removed', this.getItem());

          if (! this.hasUser()) {
            this.redirect();
          }
        } else {
          alert(result.data.errors.general);
          $(document).trigger('bvm_shortcode_favorites_error', this.getItem());
        }
      })
      .fail(error => {
        alert('Can\'t remove team to favorites. Try again later.');
        console.error(error);
      });
  }

  equal(first, second) {
    return JSON.stringify(first) === JSON.stringify(second);
  }

  getItem() {
    switch (this.type) {
      case 'league':
        return this.config.leagues[0];

      case 'team':
          return this.config.teams[0];

      default:
        return null;
    }
  }

  hasItem() {
    switch (this.type) {
      case 'league':
        return this.getItemsIn('leagues').some((item) =>
          item.id === this.config.leagues[0].id
        );

      case 'team':
        return this.getItemsIn('teams').some((item) =>
          item.id === this.config.teams[0].id &&
          item.sport === this.config.teams[0].sport &&
          item.gender === this.config.teams[0].gender
        );

      default:
        return false;
    }
  }

  getItemsIn(key) {
    switch (key) {
      case 'leagues':
        return window.bvm.user['leagues'];

      case 'teams':
        return window.bvm.user['teams'];

      default:
        return [];
    }
  }

  hasUser() {
    return window.bvm.user.loggedin;
  }

  /**
   * @todo make dynamic
   */
  redirect() {
    window.location.href = '/favorites/';
  }
}

export default Favorites;
